import { Component } from '@angular/core';
import { CardComponent } from '@3ddv/software-division-components/backoffice/card';
import { ButtonComponent } from '@3ddv/software-division-components/generic/button';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.css',
  imports: [CardComponent, ButtonComponent],
})
export class NotFoundComponent {
  public retry(): void {
    window.location.reload();
  }
}
